import { Link } from "react-router-dom"
import Input from "../../blocks/Input"
import { useForm } from "../../hooks/useForm"
import './roles-header.css'
import context from "../../scripts/context"
import { useRef, useState } from "react"
import RoleModal from '../Modals/Role-modal'


const RolesHeader = ({count, onFilter}) => {

    const roleModal = useRef()
    const [inputs, setInputs] = useState(context.getRoleInputFilter())
 
    const onRoleInputFilter = (ins) => {
        setInputs({
            ...ins
         })
    }

    context.addListenerRoleInputFilter((ins)=>{onRoleInputFilter(ins)})


    const handleSearchChange = (value, newName)=>{
        console.log(newName,  value)
        const ni = {
            ...inputs,
            [newName]: {
                ...inputs.name,
                value: value
            },
        }
        setInputs(ni)
        context.setRoleInputFilter(ni)
    }

    const checkEnter = (event) => {
        if (event.keyCode === 13) {
            onFilter(inputs)
        }
    };

    const openModal = () => roleModal.current.openModal()

    return (
        <div className="role-searchbar">
            <div className="searchbar__input">
                <Input inputField={inputs.name} onChange={handleSearchChange} onKeyDown={e => checkEnter(e)} />
            </div>
            <div className="searchbar__filter">
                <button onClick={ () => openModal()}  >Filter {(count!== 0 ? <span>{count}</span> : '')}</button>
            </div>
            <div className="searchbar__btn">
                <Link to={"/agent/roles/single?type=create"}>
                    <button> + Add New Role</button>
                </Link>
            </div>
        <RoleModal ref={roleModal} onFilter={(inputs) => {setInputs(inputs); onFilter(inputs);}} />
    </div>
    )

}

export default RolesHeader